import React, { createContext, useCallback, useContext, useState } from "react";
import { useNotification } from "../notification-context";
import { postAuthenticatedRequest } from "../../../utils/api/requests/request";
import { cleanObject } from "../../../utils/helper/format";
import { downloadFileType } from "../../../shared/constants/constants";
import { downloadFile } from "../../../utils/helper/util";

const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
  const { triggerNotification } = useNotification();
  const [allCustomers, setAllCustomers] = useState(null);
  const [allContacts, setAllContacts] = useState(null);
  const [isLoanDetailsLoading, setIsLoanDetailsLoading] = useState(false);
  const [isUserDetailsLoading, setIsUserDetailsLoading] = useState(false);
  const [isContactDetailsLoading, setIsContactDetailsLoading] = useState(false);
  const [tabsDetailLoading, setTabsDetailLoading] = useState({
    identityLoading: false,
    basicInformationLoading: false,
    customerLoanApplcationsLoading: false,
    loanDetailsLoading: false,
    guarantorsLoading: false,
    salaryHistoryLoading: false,
    creditBureauSearches: false,
    addressInformatoinLoading: false,
    employmentInformatoinLoading: false,
    nokInformatoinLoading: false,
    collectionInformation: false,
    disbursementInformation: false,
    repaymentScheduleInformation: false,
    linkedProfileLoading: false,
    deductionsLoading: false,
    loanDocumentsLoading: false,
    livenessCheckLoading: false,
  });
  const [isAllCustomerLoading, setIsAllCustomerLoading] = useState(false);
  const [isRetrievingProfileByCustomerId, setIsRetrievingProfileByCustomerId] =
    useState(false);
  const [isDownloadingReport, setIsDownloadingReport] = useState(false);
  const [isWaivingRepaymentInstallment, setIsWaivingRepaymentInstallment] =
    useState(false);

  const [filter, setFilter] = useState({
    status: "",
    customerType: "",
    searchText: "",
    startDate: "",
    endDate: "",
  });

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [customerDetails, setCustomerDetails] = useState(null);
  const [contactDetails, setContactDetails] = useState(null);
  const [customerBasicDetails, setCustomerBasicDetails] = useState(null);
  const [addressDetails, setAddressDetails] = useState(null);
  const [employmentDetails, setEmploymentDetails] = useState(null);
  const [nokDetails, setNokDetails] = useState(null);
  const [identityDetails, setIdentityDetails] = useState(null);
  const [kycInformation, setKYCInformation] = useState(null);
  const [customerLoanApplications, setCustomerLoanApplications] =
    useState(null);
  const [loanDetails, setLoanDetails] = useState(null);
  const [guarantors, setGuarantors] = useState(null);
  const [deductions, setDeductions] = useState(null);
  const [salaryHistory, setSalaryHistory] = useState(null);
  const [creditBureauSearches, setCreditBureauSearches] = useState(null);
  const [collectionInformation, setCollectionInformation] = useState(null);
  const [disbursementInformation, setDisbursementInformation] = useState(null);
  const [repaymentScheduleInformation, setRepaymentScheduleInformation] = useState(null);
  const [linkedProfiles, setLinkedProfiles] = useState(null);
  const [userLivenessCheck, setUserLivenessCheck] = useState(null);
  const [activeModal, setActiveModal] = useState(null);
  const [loanDocuments, setLoanDocuments] = useState(null);
  const [customerDocuments, setCustomerDocuments] = useState(null);
  const openModal = (modalName) => {
    setActiveModal(modalName);
  };

  const closeModal = () => {
    setActiveModal(null);
  };
  const getAllContacts = useCallback(async () => {
    try {
      setIsAllCustomerLoading(true);

      // Filter out properties with empty values
      const cleanedFilter = cleanObject({ ...filter, ...pagination });

      console.log("cleaned filter is", cleanedFilter);

      const response = await postAuthenticatedRequest(
        "RetrieveContactListQuery",
        cleanedFilter,
        true,
      );

      const result = response?.outData;
      if (result?.isSuccessful) {
        console.log("result?.data from customers", result?.data);
        setAllContacts(result);
      } else {
        triggerNotification({
          type: "error",
          message: "Error",
          description: result?.message,
        });
      }
    } catch (error) {
      triggerNotification({
        type: "error",
        message: "Error",
        description: error?.message,
      });
    } finally {
      setIsAllCustomerLoading(false);
    }
  }, [triggerNotification, filter, pagination]);

  const getAllCustomers = useCallback(async () => {
    try {
      setIsAllCustomerLoading(true);

      // Filter out properties with empty values
      const cleanedFilter = cleanObject({ ...filter, ...pagination });

      console.log("cleaned filter is", cleanedFilter);

      const response = await postAuthenticatedRequest(
        // "RefreshFeatureToggleCommand",
        "RetrieveSelfServiceCustomersQuery",
        cleanedFilter,
      );

      const result = response?.outData;
      if (result?.isSuccessful) {
        console.log("result?.data from customers", result?.data);
        setAllCustomers(result);
      } else {
        triggerNotification({
          type: "error",
          message: "Error",
          description: result?.message,
        });
      }
    } catch (error) {
      triggerNotification({
        type: "error",
        message: "Error",
        description: error?.message,
      });
    } finally {
      setIsAllCustomerLoading(false);
    }
  }, [triggerNotification, filter, pagination]);

  // download customer report
  const downloadCustomersReport = useCallback(async () => {
    try {
      setIsDownloadingReport(true);

      // Filter out properties with empty values
      const cleanedFilter = cleanObject({
        ...filter,
        ...pagination,
        isExport: true,
        fileExportName: "CustomerReport",
        exportFields: {
          cbCustomerId: "Customer ID",
          displayName: "Display Name",
          userType: "User Type",
          branchName: "Branch",
          createdAt: "Reg. Date",
          emailAddress: "Email",
          mobileNumber: "Phone",
          userStatusDescription: "Status",
        },
      });

      const response = await postAuthenticatedRequest(
        "RetrieveSelfServiceCustomersQuery",
        cleanedFilter,
      );

      const result = response?.outData;
      console.log("result from download customers", result);
      if (result?.isSuccessful) {
        downloadFile(result?.data, "Customer_Report", downloadFileType.EXCEL);

        triggerNotification({
          type: "success",
          message: "Success",
          description: result?.message || "Customer report downloaded",
        });
      } else {
        triggerNotification({
          type: "error",
          message: "Error",
          description: result?.message,
        });
      }
    } catch (error) {
      triggerNotification({
        type: "error",
        message: "Error",
        description: error?.message,
      });
    } finally {
      setIsDownloadingReport(false);
    }
  }, [triggerNotification, filter, pagination]);

  // API call function to get loan details by ID
  const getLoanQuoteDetails = useCallback(
    async (loanQuoteId) => {
      try {
        setIsLoanDetailsLoading(true);
        const response = await postAuthenticatedRequest(
          "GetLoanQuoteWithDetailsQuery",
          { loanQuoteId: Number(loanQuoteId) },
        );
        const result = response?.outData;
        if (result?.isSuccessful) {
          setCustomerDetails(result?.data);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message,
        });
      } finally {
        setIsLoanDetailsLoading(false);
      }
    },
    [triggerNotification],
  );

  // API call function to get user details by ID
  const getUserDetails = useCallback(
    async (userId) => {
      try {
        setIsUserDetailsLoading(true);
        const response = await postAuthenticatedRequest(
          "GetUserWithDetailsQuery",
          { userId },
        );

        const result = response?.outData;
        setIsUserDetailsLoading(false);
        if (result?.isSuccessful) {
          setCustomerDetails(result?.data);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message,
        });
      } finally {
        setIsUserDetailsLoading(false);
      }
    },
    [triggerNotification],
  );

  // API call function to get user details by ID
  const getCustomerDetails = useCallback(
    async (id) => {
      try {
        setIsContactDetailsLoading(true);
        const response = await postAuthenticatedRequest(
          "RetrieveContactByIdQuery",
          { id },
          true,
        );

        const result = response?.outData;
        setIsContactDetailsLoading(false);
        if (result?.isSuccessful) {
          setContactDetails(result?.data);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message,
        });
      } finally {
        setIsContactDetailsLoading(false);
      }
    },
    [triggerNotification],
  );

  const getCustomerDocuments = useCallback(
    async (userId, pagination) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          customerDocumentsLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetUserDocumentsQuery",
          { selfServiceUserId: userId, ...pagination },
        );
        const result = response?.outData;
        setTabsDetailLoading((prev) => ({
          ...prev,
          customerDocumentsLoading: false,
        }));
        if (result?.isSuccessful) {
          setCustomerDocuments(result);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch customer documents",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          customerDocumentsLoading: false,
        }));
      }
    },
    [triggerNotification],
  );
  const getCustomerBasicInformation = useCallback(
    async (userId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          basicInformationLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetCustomerBasicDetailsQuery",
          { userId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          basicInformationLoading: false,
        }));
        if (result?.isSuccessful) {
          setCustomerBasicDetails(result?.data);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch basic information",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          basicInformationLoading: false,
        }));
      }
    },
    [triggerNotification],
  );

  const getCustomerKYCInformation = useCallback(
    async (userId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          kycInformationLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetCustomerKycInformationQuery",
          { userId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          kycInformationLoading: false,
        }));
        if (result?.isSuccessful) {
          setKYCInformation(result?.data?.kycInformations);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch basic information",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          kycInformationLoading: false,
        }));
      }
    },
    [triggerNotification],
  );

  const getCustomerAddressInformation = useCallback(
    async (userId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          addressInformatoinLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetCustomerAddressDetailsQuery",
          { userId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          addressInformatoinLoading: false,
        }));
        if (result?.isSuccessful) {
          setAddressDetails(result?.data);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch basic information",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          addressInformatoinLoading: false,
        }));
      }
    },
    [triggerNotification],
  );

  const getCustomerNOKInformation = useCallback(
    async (userId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          nokInformatoinLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetCustomerNextOfKinDetailsQuery",
          { userId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          nokInformatoinLoading: false,
        }));
        if (result?.isSuccessful) {
          setNokDetails(result?.data);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch basic information",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          nokInformatoinLoading: false,
        }));
      }
    },
    [triggerNotification],
  );

  const getCustomerEmploymentInformation = useCallback(
    async (userId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          employmentInformatoinLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetCustomerEmploymentDetailsQuery",
          { userId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          employmentInformatoinLoading: false,
        }));
        if (result?.isSuccessful) {
          setEmploymentDetails(result?.data);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch basic information",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          employmentInformatoinLoading: false,
        }));
      }
    },
    [triggerNotification],
  );

  const getCustomerIdentity = useCallback(
    async (userId) => {
      try {
        setTabsDetailLoading((prev) => ({ ...prev, identityLoading: true }));
        const response = await postAuthenticatedRequest(
          "GetCustomerIdentityDetailsQuery",
          { userId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({ ...prev, identityLoading: false }));
        if (result?.isSuccessful) {
          setIdentityDetails(result?.data);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message,
        });
      } finally {
        setTabsDetailLoading((prev) => ({ ...prev, identityLoading: false }));
      }
    },
    [triggerNotification],
  );

  const getCustomerLoanApplication = useCallback(
    async (userId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          customerLoanApplcationsLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetLoanQuotesWithFiltersQuery",
          { userId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          customerLoanApplcationsLoading: false,
        }));
        if (result?.isSuccessful) {
          setCustomerLoanApplications(result?.data?.loanQuotes);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch loan applications",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          customerLoanApplcationsLoading: false,
        }));
      }
    },
    [triggerNotification],
  );
  const getLoanDetails = useCallback(
    async (userId, loanId) => {
      console.log("the id passed is", { userId, loanId });
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          loanDetailsLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetCustomerLoanDetailsQuery",
          { userId, loanQuoteId: loanId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          loanDetailsLoading: false,
        }));

        console.log("result from loan details", result);
        if (result?.isSuccessful) {
          setLoanDetails(result?.data);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch loan details",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          loanDetailsLoading: false,
        }));
      }
    },
    [triggerNotification],
  );
  const getGuarantors = useCallback(
    async (userId, loanId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          guarantorsLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetCustomerLoanGuarantorsQuery",
          { userId, loanQuoteId: loanId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          guarantorsLoading: false,
        }));

        if (result?.isSuccessful) {
          setGuarantors(
            Array.isArray(result?.data)
              ? result.data
              : result?.data?.guarantors || [],
          );
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch guarantor",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          guarantorsLoading: false,
        }));
      }
    },
    [triggerNotification],
  );
  const getLoanDocuments = useCallback(
    async (loanQuoteId, pagination) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          loanDocumentsLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetLoanQuoteDocumentsQuery",
          { loanQuoteId, ...pagination },
        );
        const result = response?.outData;
        setTabsDetailLoading((prev) => ({
          ...prev,
          loanDocumentsLoading: false,
        }));
        if (result?.isSuccessful) {
          setLoanDocuments(result);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch loan documents",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          loanDocumentsLoading: false,
        }));
      }
    },
    [triggerNotification],
  );
  const getDeductions = useCallback(
    async (userId, loanId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          deductionsLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetLoanDeductionsQuery",
          { userId, loanRequestId: loanId },
        );
        const result = response?.outData;
        setTabsDetailLoading((prev) => ({
          ...prev,
          deductionsLoading: false,
        }));
        if (result?.isSuccessful) {
          setDeductions(result?.data?.deductions);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch deductions",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          deductionsLoading: false,
        }));
      }
    },
    [triggerNotification],
  );
  const getSalaryHistory = useCallback(
    async (userId, loanId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          salaryHistoryLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetCustomerLoanSalaryHistoryQuery",
          { userId, loanQuoteId: loanId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          salaryHistoryLoading: false,
        }));

        if (result?.isSuccessful) {
          setSalaryHistory(result?.data?.salaryHistory);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch guarantor",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          salaryHistoryLoading: false,
        }));
      }
    },
    [triggerNotification],
  );
  const getCreditBureauSearches = useCallback(
    async (userId, loanId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          creditBureauSearches: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetCustomerLoanCreditBureauSearchesQuery",
          { userId, loanQuoteId: loanId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          creditBureauSearches: false,
        }));

        console.log("result from credit bureau", result);
        if (result?.isSuccessful) {
          setCreditBureauSearches(result?.data?.creditBureauSearches);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch guarantor",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          creditBureauSearches: false,
        }));
      }
    },
    [triggerNotification],
  );

  const getCollectionInformation = useCallback(
    async (userId, loanId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          collectionInformation: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetLoanCollectionInformationQuery",
          { userId, loanRequestId: loanId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          collectionInformation: false,
        }));

        console.log("result from collection intformation", result);
        if (result?.isSuccessful) {
          setCollectionInformation(result?.data?.collectionInformation);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description:
            error?.message || "Failed to fetch collection information",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          collectionInformation: false,
        }));
      }
    },
    [triggerNotification],
  );
  const getDisbursementInformation = useCallback(
    async (userId, loanId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          disbursementInformation: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetLoanDisbursementInformationQuery",
          { userId, loanRequestId: loanId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          disbursementInformation: false,
        }));

        console.log("result from disbursement information", result);
        if (result?.isSuccessful) {
          setDisbursementInformation(result?.data?.disbursementInformation);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description:
            error?.message || "Failed to fetch disbursement information",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          disbursementInformation: false,
        }));
      }
    },
    [triggerNotification],
  );

  const getRepaymentScheduleInformation = useCallback(
    async (userId, loanId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          repaymentScheduleInformation: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetRepaymentScheduleQuery",
          { userId, loanRequestId: loanId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          repaymentScheduleInformation: false,
        }));

        console.log("result from disbursement information", result);
        if (result?.isSuccessful) {
          setRepaymentScheduleInformation(result?.data);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description:
            error?.message || "Failed to fetch disbursement information",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          repaymentScheduleInformation: false,
        }));
      }
    },
    [triggerNotification],
  );

  const waiveRepaymentScheduleInstallment = useCallback(
    async ({ userId, loanId, scheduleRow, reason }) => {
      try {
        setIsWaivingRepaymentInstallment(true);

        const scheduleId =
          scheduleRow?.repaymentScheduleId ??
          scheduleRow?.scheduleId ??
          scheduleRow?.id;

        const response = await postAuthenticatedRequest(
          "WaiveRepaymentScheduleInstallmentCommand",
          {
            userId,
            loanRequestId: loanId,
            repaymentScheduleId: scheduleId,
            scheduleId,
            installmentNumber: scheduleRow?.installmentNumber,
            reason,
          },
        );

        const result = response?.outData;
        if (result?.isSuccessful) {
          triggerNotification({
            type: "success",
            message: "Success",
            description:
              result?.message || "Repayment installment waived successfully",
          });
          await getRepaymentScheduleInformation(userId, loanId);
          return true;
        }

        triggerNotification({
          type: "error",
          message: "Error",
          description:
            result?.message || "Failed to waive repayment installment",
        });
        return false;
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description:
            error?.message || "Failed to waive repayment installment",
        });
        return false;
      } finally {
        setIsWaivingRepaymentInstallment(false);
      }
    },
    [getRepaymentScheduleInformation, triggerNotification],
  );
  const getLinkedProfile = useCallback(
    async (userId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          linkedProfileLoading: true,
        }));
        const response = await postAuthenticatedRequest(
          "GetAllLinkedProfilesQuery",

          { userId },
        );

        const result = response?.outData;

        setTabsDetailLoading((prev) => ({
          ...prev,
          linkedProfileLoading: false,
        }));

        console.log("result from linked profile", result);
        if (result?.isSuccessful) {
          setLinkedProfiles(result?.data);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message || "Failed to fetch linked profile",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          linkedProfileLoading: false,
        }));
      }
    },
    [triggerNotification],
  );
  const getProfileByCustomerId = async ({
    accountNumber,
    coreBankingCustomerId,
  }) => {
    try {
      setIsRetrievingProfileByCustomerId(true);
      const response = await postAuthenticatedRequest(
        "GetProfileByCustomerIdAndAccountQuery",
        { accountNumber, coreBankingCustomerId },
      );

      const result = response?.outData;

      setIsRetrievingProfileByCustomerId(false);

      console.log("profile result from account number", result);
      if (result?.isSuccessful) {
        triggerNotification({
          type: "success",
          message: "Success",
          description: result?.message,
        });
        return result?.data;
      } else {
        triggerNotification({
          type: "error",
          message: "Error",
          description: result?.message,
        });
      }
    } catch (error) {
      triggerNotification({
        type: "error",
        message: "Error",
        description: error?.message || "Failed to fetch profile by ID",
      });
    } finally {
      setIsRetrievingProfileByCustomerId(false);
    }
  };

  const getUserLivenessCheck = useCallback(
    async (userId) => {
      try {
        setTabsDetailLoading((prev) => ({
          ...prev,
          livenessCheckLoading: true,
        }));

        const response = await postAuthenticatedRequest(
          "GetUserLivenessCheckQuery",
          { userId: Number(userId) },
        );

        const result = response?.outData;
        if (result?.isSuccessful) {
          setUserLivenessCheck(result?.data);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description:
              result?.message || "Failed to fetch user liveness check details.",
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description:
            error?.message || "Failed to fetch user liveness check details.",
        });
      } finally {
        setTabsDetailLoading((prev) => ({
          ...prev,
          livenessCheckLoading: false,
        }));
      }
    },
    [triggerNotification],
  );

  return (
    <CustomerContext.Provider
      value={{
        allCustomers,
        isAllCustomerLoading,
        isLoanDetailsLoading,
        customerBasicDetails,
        identityDetails,
        kycInformation,
        customerLoanApplications,
        loanDetails,
        guarantors,
        deductions,
        salaryHistory,
        creditBureauSearches,
        collectionInformation,
        disbursementInformation,
        isUserDetailsLoading,
        isDownloadingReport,
        allContacts,
        getAllCustomers,
        getAllContacts,
        tabsDetailLoading,
        isRetrievingProfileByCustomerId,
        addressDetails,
        employmentDetails,
        nokDetails,
        customerDocuments,
        loanDocuments,
        linkedProfiles,
        userLivenessCheck,
        getCustomerNOKInformation,
        getCustomerDocuments,
        getCustomerEmploymentInformation,
        getCustomerAddressInformation,
        getCustomerIdentity,
        downloadCustomersReport,
        getUserDetails,
        getCustomerBasicInformation,
        getCustomerKYCInformation,
        setCustomerBasicDetails,
        getCustomerLoanApplication,
        getLoanDetails,
        getLoanQuoteDetails,
        getGuarantors,
        getDeductions,
        getSalaryHistory,
        getCreditBureauSearches,
        getCollectionInformation,
        getLoanDocuments,
        isContactDetailsLoading,
        repaymentScheduleInformation,
        isWaivingRepaymentInstallment,
        contactDetails,
        getCustomerDetails,
        getDisbursementInformation,
        getRepaymentScheduleInformation ,
        waiveRepaymentScheduleInstallment,
        getLinkedProfile,
        getProfileByCustomerId,
        getUserLivenessCheck,
        filter,
        setFilter,
        pagination,
        setPagination,
        customerDetails,
        activeModal,
        setActiveModal,
        openModal,
        closeModal,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomer = () => {
  return useContext(CustomerContext);
};

// GetCustomerIdentityDetailsQuery
